import { useState } from 'react';
import { type YoutubeVideoData } from '@/api/ai/youtube/types';
import { YoutubeIframe } from './YoutubeIframe';
import { YoutubeThumbnail } from './YoutubeThumbnail';
export const YoutubePlayer = ({
  videoData
}: {
  videoData: YoutubeVideoData;
}) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const handlePlay = () => {
    setIsPlaying(true);
  };
  return <div className="relative aspect-video w-full overflow-hidden rounded-md bg-gray-100" data-sentry-component="YoutubePlayer" data-sentry-source-file="YoutubePlayer.tsx">
      {isPlaying ? <YoutubeIframe videoData={videoData} isPlaying={isPlaying} /> : <YoutubeThumbnail videoData={videoData} onClick={handlePlay} />}
    </div>;
};